export default __webpack_public_path__ + "static/media/76_mobile.d9d94146.jpg";